import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=b7468dd2&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&lang=ts&"
export * from "./InfoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=b7468dd2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7468dd2",
  null
  
)

export default component.exports